//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitData.js";
import "../GeometricUtilities/GeometricUtilities.CurveFitJoin.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.LawBuilder.js";
import "../no/ExpressionSectionSetList.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"AngularTolerance",1,0],[0,"AssociativeOutputOption",1,0],[1,"CurveFitData",0,"GeometricUtilities.CurveFitData",0],[1,"CurveFitJoinData",0,"GeometricUtilities.CurveFitJoin",1],[0,"CurveOffsetType",1,0],[0,"DirectionVector",1,"Direction",0],[0,"DistanceTolerance",1,0],[0,"ExtendMethod",1,0],[0,"ExtendToFaceOption",1,0],[0,"FaceCollector",1,"ScCollector",0],[0,"FilletDirectionVector",1,"Direction",0],[0,"FilletOption",1,0],[0,"FilletRadius",1,"Expression",0],[1,"Law",0,"GeometricUtilities.LawBuilder",0],[0,"LawString",1,"Section",0],[0,"LawStringFlip",1,0],[0,"OffsetDirectionOption",1,0],[0,"OffsetDistType",1,0],[0,"OffsetMode",1,0],[1,"Offsets",0,"ExpressionSectionSetList",0],[0,"PointString",1,"Section",0],[0,"ProjectPlaneNormal",1,"Direction",0],[0,"RemoveSelfIntersections",1,0],[0,"SplitCurveOption",1,0],[0,"ThroughPoint",1,"Point",0],[0,"TrimMethod",1,0],[0,"TrimToFaceEdgesOption",1,0]],[[["section"],"FlipAllOffsetsOfSection",{},1,0],[["seldimitem"],"FlipOffset",{},1,0],[["post_status_changed"],"UpdatePostStatusFlag",{},1,0],[["update_law_parm"],"UpdateCurvesStatus",{},1,0],[["const_to_variable","section_from"],"CloneSection",{R_:{section_clone:"Section"}},2,0],[["const_to_variable","first_section","second_section"],"SynchronizeSections",{},3,0],[[],"UpdateFaces",{},0,0],[["section"],"UpdateSectionData",{R_:{flip_direction:''}},1,0],[["pointType"],"SynchronizeSectionForValueOrPoint",{},1,0]],[]];
SPLM.Features.AOCSBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AOCSBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.AOCSBuilder.OffsetType = Object.freeze({
    "Chordal" : "Chordal", "Arclength" : "Arclength", "Geodesic" : "Geodesic", "Tangential" : "Tangential", "Projectdistance" : "Projectdistance"});

SPLM.Features.AOCSBuilder.Trim = Object.freeze({
    "None" : "None", "WithinSection" : "WithinSection"});

SPLM.Features.AOCSBuilder.Extend = Object.freeze({
    "None" : "None", "WithinSection" : "WithinSection"});

SPLM.Features.AOCSBuilder.ExtendToFace = Object.freeze({
    "None" : "None", "Boundary" : "Boundary"});

SPLM.Features.AOCSBuilder.OffsetDistanceType = Object.freeze({
    "Constant" : "Constant", "Variable" : "Variable"});

SPLM.Features.AOCSBuilder.OffsetDirection = Object.freeze({
    "NormalToCurve" : "NormalToCurve", "NormalToVector" : "NormalToVector"});

SPLM.Features.AOCSBuilder.FilletOptions = Object.freeze({
    "NoFillet" : "NoFillet", "Vector" : "Vector", "BestFit" : "BestFit", "ProjectedVector" : "ProjectedVector"});

SPLM.Features.AOCSBuilder.CurveOffsetTypes = Object.freeze({
    "Value" : "Value", "ThroughPoint" : "ThroughPoint"});

export default SPLM;